// Generated by scripts/generate-airport-codes.mjs from OurAirports (public domain) — do not edit by hand.
import type { AirportDetail } from './airport-types';

// One lazy chunk per state or province, so a page only downloads its own region's airports.
export const AIRPORT_DATA: Record<string, () => Promise<AirportDetail[]>> = {
  'CA-AB': () => import('./data/ca-ab').then(m => m.AIRPORTS),
  'CA-BC': () => import('./data/ca-bc').then(m => m.AIRPORTS),
  'CA-MB': () => import('./data/ca-mb').then(m => m.AIRPORTS),
  'CA-NB': () => import('./data/ca-nb').then(m => m.AIRPORTS),
  'CA-NL': () => import('./data/ca-nl').then(m => m.AIRPORTS),
  'CA-NS': () => import('./data/ca-ns').then(m => m.AIRPORTS),
  'CA-NT': () => import('./data/ca-nt').then(m => m.AIRPORTS),
  'CA-NU': () => import('./data/ca-nu').then(m => m.AIRPORTS),
  'CA-ON': () => import('./data/ca-on').then(m => m.AIRPORTS),
  'CA-PE': () => import('./data/ca-pe').then(m => m.AIRPORTS),
  'CA-QC': () => import('./data/ca-qc').then(m => m.AIRPORTS),
  'CA-SK': () => import('./data/ca-sk').then(m => m.AIRPORTS),
  'CA-YT': () => import('./data/ca-yt').then(m => m.AIRPORTS),
  'IN-AN': () => import('./data/in-an').then(m => m.AIRPORTS),
  'IN-AP': () => import('./data/in-ap').then(m => m.AIRPORTS),
  'IN-AR': () => import('./data/in-ar').then(m => m.AIRPORTS),
  'IN-AS': () => import('./data/in-as').then(m => m.AIRPORTS),
  'IN-BR': () => import('./data/in-br').then(m => m.AIRPORTS),
  'IN-CH': () => import('./data/in-ch').then(m => m.AIRPORTS),
  'IN-CT': () => import('./data/in-ct').then(m => m.AIRPORTS),
  'IN-DH': () => import('./data/in-dh').then(m => m.AIRPORTS),
  'IN-DL': () => import('./data/in-dl').then(m => m.AIRPORTS),
  'IN-GA': () => import('./data/in-ga').then(m => m.AIRPORTS),
  'IN-GJ': () => import('./data/in-gj').then(m => m.AIRPORTS),
  'IN-HP': () => import('./data/in-hp').then(m => m.AIRPORTS),
  'IN-HR': () => import('./data/in-hr').then(m => m.AIRPORTS),
  'IN-JH': () => import('./data/in-jh').then(m => m.AIRPORTS),
  'IN-JK': () => import('./data/in-jk').then(m => m.AIRPORTS),
  'IN-KA': () => import('./data/in-ka').then(m => m.AIRPORTS),
  'IN-KL': () => import('./data/in-kl').then(m => m.AIRPORTS),
  'IN-LA': () => import('./data/in-la').then(m => m.AIRPORTS),
  'IN-LD': () => import('./data/in-ld').then(m => m.AIRPORTS),
  'IN-ML': () => import('./data/in-ml').then(m => m.AIRPORTS),
  'IN-MM': () => import('./data/in-mm').then(m => m.AIRPORTS),
  'IN-MN': () => import('./data/in-mn').then(m => m.AIRPORTS),
  'IN-MP': () => import('./data/in-mp').then(m => m.AIRPORTS),
  'IN-MZ': () => import('./data/in-mz').then(m => m.AIRPORTS),
  'IN-NL': () => import('./data/in-nl').then(m => m.AIRPORTS),
  'IN-OR': () => import('./data/in-or').then(m => m.AIRPORTS),
  'IN-PB': () => import('./data/in-pb').then(m => m.AIRPORTS),
  'IN-PY': () => import('./data/in-py').then(m => m.AIRPORTS),
  'IN-RJ': () => import('./data/in-rj').then(m => m.AIRPORTS),
  'IN-TG': () => import('./data/in-tg').then(m => m.AIRPORTS),
  'IN-TN': () => import('./data/in-tn').then(m => m.AIRPORTS),
  'IN-TR': () => import('./data/in-tr').then(m => m.AIRPORTS),
  'IN-UP': () => import('./data/in-up').then(m => m.AIRPORTS),
  'IN-UT': () => import('./data/in-ut').then(m => m.AIRPORTS),
  'IN-WB': () => import('./data/in-wb').then(m => m.AIRPORTS),
  'US-AK': () => import('./data/us-ak').then(m => m.AIRPORTS),
  'US-AL': () => import('./data/us-al').then(m => m.AIRPORTS),
  'US-AR': () => import('./data/us-ar').then(m => m.AIRPORTS),
  'US-AZ': () => import('./data/us-az').then(m => m.AIRPORTS),
  'US-CA': () => import('./data/us-ca').then(m => m.AIRPORTS),
  'US-CO': () => import('./data/us-co').then(m => m.AIRPORTS),
  'US-CT': () => import('./data/us-ct').then(m => m.AIRPORTS),
  'US-DC': () => import('./data/us-dc').then(m => m.AIRPORTS),
  'US-DE': () => import('./data/us-de').then(m => m.AIRPORTS),
  'US-FL': () => import('./data/us-fl').then(m => m.AIRPORTS),
  'US-GA': () => import('./data/us-ga').then(m => m.AIRPORTS),
  'US-HI': () => import('./data/us-hi').then(m => m.AIRPORTS),
  'US-IA': () => import('./data/us-ia').then(m => m.AIRPORTS),
  'US-ID': () => import('./data/us-id').then(m => m.AIRPORTS),
  'US-IL': () => import('./data/us-il').then(m => m.AIRPORTS),
  'US-IN': () => import('./data/us-in').then(m => m.AIRPORTS),
  'US-KS': () => import('./data/us-ks').then(m => m.AIRPORTS),
  'US-KY': () => import('./data/us-ky').then(m => m.AIRPORTS),
  'US-LA': () => import('./data/us-la').then(m => m.AIRPORTS),
  'US-MA': () => import('./data/us-ma').then(m => m.AIRPORTS),
  'US-MD': () => import('./data/us-md').then(m => m.AIRPORTS),
  'US-ME': () => import('./data/us-me').then(m => m.AIRPORTS),
  'US-MI': () => import('./data/us-mi').then(m => m.AIRPORTS),
  'US-MN': () => import('./data/us-mn').then(m => m.AIRPORTS),
  'US-MO': () => import('./data/us-mo').then(m => m.AIRPORTS),
  'US-MS': () => import('./data/us-ms').then(m => m.AIRPORTS),
  'US-MT': () => import('./data/us-mt').then(m => m.AIRPORTS),
  'US-NC': () => import('./data/us-nc').then(m => m.AIRPORTS),
  'US-ND': () => import('./data/us-nd').then(m => m.AIRPORTS),
  'US-NE': () => import('./data/us-ne').then(m => m.AIRPORTS),
  'US-NH': () => import('./data/us-nh').then(m => m.AIRPORTS),
  'US-NJ': () => import('./data/us-nj').then(m => m.AIRPORTS),
  'US-NM': () => import('./data/us-nm').then(m => m.AIRPORTS),
  'US-NV': () => import('./data/us-nv').then(m => m.AIRPORTS),
  'US-NY': () => import('./data/us-ny').then(m => m.AIRPORTS),
  'US-OH': () => import('./data/us-oh').then(m => m.AIRPORTS),
  'US-OK': () => import('./data/us-ok').then(m => m.AIRPORTS),
  'US-OR': () => import('./data/us-or').then(m => m.AIRPORTS),
  'US-PA': () => import('./data/us-pa').then(m => m.AIRPORTS),
  'US-RI': () => import('./data/us-ri').then(m => m.AIRPORTS),
  'US-SC': () => import('./data/us-sc').then(m => m.AIRPORTS),
  'US-SD': () => import('./data/us-sd').then(m => m.AIRPORTS),
  'US-TN': () => import('./data/us-tn').then(m => m.AIRPORTS),
  'US-TX': () => import('./data/us-tx').then(m => m.AIRPORTS),
  'US-UT': () => import('./data/us-ut').then(m => m.AIRPORTS),
  'US-VA': () => import('./data/us-va').then(m => m.AIRPORTS),
  'US-VT': () => import('./data/us-vt').then(m => m.AIRPORTS),
  'US-WA': () => import('./data/us-wa').then(m => m.AIRPORTS),
  'US-WI': () => import('./data/us-wi').then(m => m.AIRPORTS),
  'US-WV': () => import('./data/us-wv').then(m => m.AIRPORTS),
  'US-WY': () => import('./data/us-wy').then(m => m.AIRPORTS),
};
